// import Alpine from 'alpinejs'
import {Html5Qrcode} from 'html5-qrcode'

Alpine.store('qrCode', {
    cameraId: null
});

export default (element) => ({
    cameraId: Alpine.store('qrCode').cameraId ?? null,
    element: null,

    settings: {
        qrbox: { width: 250, height: 250 }
    },

    init(successCallback=null, errorCallback=null) {
        this.element = new Html5Qrcode(element);

        if( this.cameraId ) {
            if(typeof successCallback === 'function') {
                successCallback();
            }

            return;
        }

        Html5Qrcode.getCameras().then(devices => {
            if (devices && devices.length) {
                this.cameraId = devices[0].id;

                if(typeof successCallback === 'function') {
                    successCallback();
                }
            }
        }).catch((error) => {
            console.error(error);

            if(typeof errorCallback === 'function') {
                errorCallback(error);
                return;
            }

            window.$wireui.notify({
                title: 'Error starting the QR Code reader',
                description: 'The application could not start the reader, you will need to allow the app to access your camera.',
                icon: 'error'
            });
        });
    },

    async getFileFromUrl(url, name, defaultType = 'image/jpeg'){
        const response = await fetch(url);
        const data = await response.blob();

        return new File([data], name, {
          type: data.type || defaultType,
        });
    },

    async scan(qrCodeSuccessCallback, qrCodeErrorCallback=null) {
        if(!this.cameraId) {
            console.error('Error when trying to scan!');
            return;
        }

        this.element.start(
            { facingMode: "environment" },
            this.settings,
            qrCodeSuccessCallback,
            qrCodeErrorCallback
        ).catch((error) => {
            console.error(error);
            window.$wireui.notify({
                title: 'Error starting reader',
                description: 'We had a problem trying to start the player, please try again!',
                icon: 'error'
            });
        });
    },

    stop(successCallback=null, errorCallback=null) {
        if(!this.cameraId) {
            if(typeof successCallback === 'function') {
                successCallback();
            }

            return;
        }

        this.element.stop().then(
            successCallback
        ).catch(
            errorCallback
        );
    }
});
